import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  Select,
  MenuItem,
  Box,
  Button,
  Typography,
  IconButton,
  Tabs,
  Tab,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VoiceWaveform from "./VoiceWaveform";
import { StyledButton } from "../StyledComponents";
import PastVisits from "../PastVisits/PastVisits";
import AbdmRecords from "../AbdmRecords/AbdmRecords";
import { Icons } from "./iconsRegistry";

const PastRecordsModal = ({
  openPastRecordsModal,
  handleClosePastRecordsModal,
  patientData,
  s3BucketFhir,
  care_context_list,
  selectedContextForRetrieveFhir,
  handleFhirArray,
  abdmData,
}) => {
  const [mode, setMode] = useState("Past Visits");

  return (
    <Dialog
      open={openPastRecordsModal}
      onClose={handleClosePastRecordsModal}
      fullWidth
      maxWidth="sm"
      // maxWidth="lg"
    >
      {/* Header */}
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: "bold",
          fontSize: "1.2rem",
          color: "#ffff",
          // backgroundImage: `url(${Icons.modal_blue})`,
          backgroundColor: "#213360",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        Patient’s Past Records
        <IconButton onClick={handleClosePastRecordsModal}>
          <CloseIcon
            sx={{
              color: "#FFFFFF",
              fontSize: { xs: "1.2rem", sm: "1.5rem" },
            }}
          />
        </IconButton>
      </DialogTitle>

      {/* Mode Tabs */}
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          marginLeft: 1,
          marginRight: 1,
        }}
      >
        <Tabs
          value={mode}
          onChange={(e, newValue) => setMode(newValue)}
          variant="fullWidth"
          textColor="inherit"
          TabIndicatorProps={{
            style: { display: "none", boxShadow: "0 4px 4px 0 #C7C7CC inset" },
          }}
        >
          <Tab
            label="Past Visits"
            value="Past Visits"
            sx={{
              fontWeight: "bold",
              bgcolor: mode === "Past Visits" ? "#E9FAF9" : "transparent",
              boxShadow: "0 4px 4px 0 #C7C7CC inset",
            }}
          />
          <Tab
            label="ABDM Records"
            value="ABDM Records"
            sx={{
              fontWeight: "bold",
              bgcolor: mode === "ABDM Records" ? "#E9FAF9" : "transparent",
              boxShadow: "0 4px 4px 0 #C7C7CC inset",
            }}
          />
        </Tabs>
      </Box>

      {/* Content */}
      <DialogContent sx={{ mt: 2 }}>
        {/* <div style={{ margin: "50px" }}> */}
        <h3 className="console-heading">{mode}</h3>
        {mode === "Past Visits" ? (
          <PastVisits
            patientData={patientData}
            fhirArrayData={s3BucketFhir}
            careContextList={care_context_list}
            selectedCareContext={selectedContextForRetrieveFhir}
            onSubmitFhirArray={handleFhirArray}
          />
        ) : (
          <></>
        )}
        {mode === "ABDM Records" && <AbdmRecords organizedArray={abdmData} />}
        {/* </div> */}
      </DialogContent>

      <DialogActions />
    </Dialog>
  );
};

export default PastRecordsModal;
